export const COUNT_BUCKET = {
    OVERALL: 0,
    ATTACK: 1,
    TWO_STRIKES: 2,
};

export const matchesCountBucket = (value, countBucket) => (
    Number(value ?? COUNT_BUCKET.OVERALL) === Number(countBucket)
);

export const getPitchTypeKey = (pitchType) => pitchType.fxsubtype || pitchType.fxtype;

export const getTrackedSwings = (pitches, pitchType, countBucket) => (
    pitches.find((p) => p.fxtype === pitchType.fxtype && p.fxsubtype === pitchType.fxsubtype
        && matchesCountBucket(p.countbucket, countBucket))?.trackedswings ?? 0
);

export const findBatTrackingEllipse = (ellipses, { isLhb, isLhp, fxtype, fxsubtype, countBucket }) => {
    const inBucket = (ellipses ?? []).filter((e) => matchesCountBucket(e.countbucket, countBucket));
    return inBucket.find((e) => e.islhb === isLhb && e.islhp === isLhp && e.fxtype === fxtype && e.fxsubtype === fxsubtype)
        || inBucket.find((e) => e.islhb === isLhb && e.islhp === isLhp && e.fxtype === fxtype && e.fxsubtype === null);
};

export const buildLeagueHeadingByPitchType = (pitchTypes, ellipses, handedness) => (
    Object.fromEntries(pitchTypes.map((pt) => {
        const match = findBatTrackingEllipse(ellipses, {
            isLhb: handedness.isLhb,
            isLhp: handedness.isLhp,
            fxtype: pt.fxtype,
            fxsubtype: pt.fxsubtype,
            countBucket: handedness.countBucket,
        });
        if (match?.headingavg == null && match?.headingsd == null) {
            return null;
        }
        return [getPitchTypeKey(pt), { avg: match.headingavg, sd: match.headingsd }];
    }).filter(Boolean))
);

export const getCountBucketToggleOptions = (translate) => ([
    { name: translate('sections.opponent.player.overall'), value: COUNT_BUCKET.OVERALL },
    { name: translate('sections.reports.pitcher.attack'), value: COUNT_BUCKET.ATTACK },
    { name: translate('components.ballcap.two-strikes'), value: COUNT_BUCKET.TWO_STRIKES },
]);
